// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__amDAT","notes":"Notes_notes__TOiSx","note":"Notes_note__26pvd","markdown":"Notes_markdown__c6r7D"};